 
export enum Mode {
  None = -1,
  Create = 0,
  Read = 1,
  Update = 2,
  Delete = 3
}


// WEBPACK FOOTER //
// ./src/types/mode.ts